// ── Head-office admin API (client) ──
// Thin wrappers around the admin Cloud Function endpoints. All are gated server-side
// to a head-office email allowlist; the browser only ever sends the signed-in token.
import { authHeader } from './firebase';

const BASE = process.env.REACT_APP_ENGINE_URL ?? 'http://localhost:3001';

// Client-side mirror of the server admin allowlist — used ONLY to decide whether to
// show the "Head Office" tab. Real access is enforced by the Cloud Functions.
export const HEAD_OFFICE_ADMINS = ['mohau@hailio.co.za', 'motaoanainv@gmail.com', 'support@hailio.co.za', 'teboho@hailio.co.za'];
export const isHeadOfficeAdmin = (email) => !!email && HEAD_OFFICE_ADMINS.includes(String(email).toLowerCase());

async function call(path, method, body) {
  const res = await fetch(BASE + path, {
    method,
    headers: { 'Content-Type': 'application/json', ...(await authHeader()) },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data && data.error) || ('Request failed (' + res.status + ')'));
  return data;
}

export const adminGetDashboard = () => call('/api/admin/dashboard', 'GET');
export const adminSaveReferral = (payload) => call('/api/admin/referral', 'POST', payload);
export const adminRecordPayout = (payload) => call('/api/admin/payout', 'POST', payload);
